import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import AddBed from "./addBed"

const AddBedContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
          <AddBed />
        </>
      </div>
    </div>
  )
}

export default AddBedContainer